import { Component, OnInit, Input, ViewChild, TemplateRef, OnDestroy } from '@angular/core';
import { Modalconfig, DefaultLanguageId } from 'src/app/shared/constants';
import { ContentBlock, AudioBlock, Asset } from 'src/app/shared/model/container.models';
import { Subscription } from 'rxjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PlaybookCommunicationService } from '../../shared/services/playbook-communication.service';
import { CommonHttpService } from 'src/app/shared/services/common-http/common-http.service';
import { clone, includes } from 'lodash';
import { ConfirmationModelComponent } from 'src/app/shared/components/confirmation-model/confirmation-model.component';
import { ActivatedRoute } from '@angular/router';
import { UtilitiesService } from 'src/app/shared/services/utilities/utilities.service';
import { LocalStorageService } from 'ngx-webstorage';
const extensionAllowedArray = ['mp3'];

@Component({
    selector: 'app-audio',
    templateUrl: './audio.component.html',
    styleUrls: ['./audio.component.scss'],
    standalone: false
})
export class AudioComponent implements OnInit, OnDestroy {

  @Input('contentBlock') contentBlock: ContentBlock;
  @ViewChild('EditAudioModal') EditAudioModal: TemplateRef<any>;
  @Input() sectionId: number;
  @Input() pageTemplateId: number;
  @Input() containerId: number;
  @Input() isdraftmode: boolean;
  showProgress = false;
  progressPercent = 0;
  updateSubsciption: Subscription;
  modalRef: BsModalRef;
  audBlock: AudioBlock;
  confModalRef: BsModalRef;
  confModalSubsciber: Subscription;
  defaultLanguageId = DefaultLanguageId;
  languageId: number;
  audioContentSubscription: Subscription;

  constructor(
    private utilitiesService: UtilitiesService,
    private commonHttpService: CommonHttpService,
    private commService: PlaybookCommunicationService,
    private modalService: BsModalService,
    private activatedRoute: ActivatedRoute,
    private storage: LocalStorageService
  ) { }

  ngOnInit() {
    // To handle Add/Edit modal opening when clicked from settings wrapper
    this.languageId = +this.activatedRoute.snapshot.queryParams.languageId || this.defaultLanguageId;
    this.updateSubsciption = this.commService.getAddEditContentBlock().subscribe((contentBlockId) => {
      if (this.contentBlock.id === contentBlockId) {
        if (!this.contentBlock.audioBlock) {
          this.contentBlock.audioBlock = new AudioBlock();
        }
        this.audBlock = clone(this.contentBlock.audioBlock);

        if((window === window.parent || ( (window != window.parent) && window.location != window.parent.location ))) {
          this.modalRef = this.modalService.show(this.EditAudioModal,
            Object.assign({ class: 'custom-modal' }, Modalconfig));
        } else {
          this.audioContentSubscription = this.storage.observe('uploadAudioContent')
          .subscribe((uploadContentBlock) => {
            if ((window !== window.parent && window.location == window.parent.location) && uploadContentBlock) {
              this.audBlock.assetId = uploadContentBlock.assetId;
              this.audBlock.caption = uploadContentBlock.caption;
              this.audBlock.external = uploadContentBlock.external;
              this.audBlock.altAssetId = uploadContentBlock.altAssetId
              this.updateAudioBlock(false);
            }
          });
          this.storage.store("audioContentBlock", this.contentBlock);
        }
      }
    });
  }

  /**
   * To set the audio asset if available
   */
  getAudioAsset(isEdit) {
    if (isEdit) {
      if (this.audBlock && this.audBlock.assetId) {
        return `/api/Assets/GetResourceById/${this.audBlock.assetId}`;
      }
    } else {
      if (this.contentBlock.audioBlock && this.contentBlock.audioBlock.assetId) {
        return `/api/Assets/GetResourceById/${this.contentBlock.audioBlock.assetId}`;
      }
    }
    return '';
  }

  /**
   * To open file input for uploading file based on file type
   * @param fileType File type
   */
  openFileDialog() {
    $('#uploadMp3').trigger('click');
  }

  /**
   * Method to handle validation of resource type before uploading
   * @param selectedFile File data for upload
   * @param fileType File type
   */
  fileSelected(event, fileType) {
    const selectedFile = event.target.files[0];
    this.showProgress = fileType;
    if (this.checkExtensionFunction(selectedFile)) {
      this.uploadResource(selectedFile);
    } else {
      const initialState = {
        msg: 'This is not a valid extension. Supported extension is: mp3',
        showCancelBtn: false
      };
      this.confModalRef = this.modalService.show(ConfirmationModelComponent,
        Object.assign({ initialState }, { class: 'custom-modal' }, Modalconfig));
      this.confModalSubsciber = this.confModalRef.content.onclose.subscribe((res) => {
        this.confModalRef.hide();
        this.confModalSubsciber.unsubscribe();
      });
    }
  }

  checkExtensionFunction(selectedFile) {
    const extensionArray = selectedFile.name.split('.');
    const extension = extensionArray[extensionArray.length - 1].toLowerCase();
    return includes(extensionAllowedArray, extension);
  }

  /**
   * Method to upload resource to database
   * @param selectedFile File data for upload
   * @param fileType File type
   */
  uploadResource(selectedFile) {
    const formData = new FormData() as any;
    this.showProgress = true;
    formData.append('file', selectedFile);
    this.commonHttpService.postWithProgress(
      {
        uri: '/api/Assets/UploadResource',
        object: formData
      }).subscribe((response: Asset | number) => {
        if (typeof response === 'number') {
          this.progressPercent = response;
        } else if (response) {
          const fileReader = new FileReader();
          fileReader.readAsDataURL(selectedFile);
          fileReader.onload = (e) => {
            this.audBlock.assetId = response.id;
            this.audBlock.asset = response;
            this.progressPercent = 0;
            this.showProgress = false;
          };
        }
      });
  }

  /**
   * Method to add or update audio block
   */
  updateAudioBlock(isClose = true) {
    const reqObj = {
      id: null,
      contentBlockId: this.contentBlock.id,
      playbookId: this.contentBlock.playbookId,
      external: this.audBlock.external,
      caption: this.audBlock.caption,
      assetId: this.audBlock.assetId,
      altAssetId: this.audBlock.altAssetId,
      pageTemplateId: this.pageTemplateId
    };
    if (this.audBlock.id) {
      reqObj.id = this.audBlock.id;
      this.commonHttpService.putWithHeaders({
        uri: '/api/AudioBlocks',
        object: reqObj
      }, {
        pageId: this.containerId,
        sectionId: this.sectionId,
        playbookId: this.contentBlock.playbookId,
        languageId: this.languageId,
        isdraftmode: this.isdraftmode
      }).subscribe((res: AudioBlock) => {
        this.contentBlock.audioBlock = res;
        if (isClose) {
          this.modalRef.hide();
        } else {
          this.audioContentSubscription.unsubscribe();
          this.storage.store("uploadAudioContent", null);
        }
      });
    } else {
      this.commonHttpService.postWithHeaders({
        uri: '/api/AudioBlocks',
        object: reqObj
      }, {
        pageId: this.containerId,
        sectionId: this.sectionId,
        playbookId: this.contentBlock.playbookId,
        languageId: this.languageId,
        isdraftmode: this.isdraftmode
      }).subscribe((res: AudioBlock) => {
        this.contentBlock.audioBlock = res;
        if(isClose) {
          this.modalRef.hide();
        } else {
          this.audioContentSubscription.unsubscribe();
          this.storage.store("uploadAudioContent", null);
        }
      });
    }
  }

  // To hide edit modal
  closeEditAudioModal() {
    this.modalRef.hide();
  }

  getAssetAzureUrl(assetUrl) {
    this.utilitiesService.getAssetAzureUrl(assetUrl)
  }

  ngOnDestroy() {
    if (this.updateSubsciption) {
      this.updateSubsciption.unsubscribe();
    }
  }
}
